import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {EventVO,  EventListVO} from './event.interfaces';
import {eventDefinition, EventState} from './event.reducers';
import {FullCrudFacade, PayloadWithRequestId, TerminateOnFirstExecutor} from '@abydos-angular/store';
import {EventRepository} from './event.repository';
import {PartnerClientVO} from '../../partner-client/store/partner-client.interfaces';
import {FetchRequest} from '@abydos-angular/core';
@Injectable()
export class EventFacade extends FullCrudFacade<EventVO, EventListVO, EventState> {

    constructor(store: Store<EventState>, private eventRepository: EventRepository) {
        super(store, eventDefinition);
    }

    getWithCallback(idValue: number, onSuccess: (result: EventVO | null | undefined) => void) {
        new TerminateOnFirstExecutor((result:PayloadWithRequestId<EventVO>) => {
          onSuccess(result.payload);
        }).run(this.eventRepository.get(idValue));
    }
}
